
/* injects from baggage-loader */

'use strict';

export default class AccountBankAccountsController {

	constructor($log, User) {
		'ngInject';

		this.heading = 'Manage Bank Accounts';

		this.$log = $log;
		this.User = User;

		this.accounts = [];

	}

	$onInit() {
		// this.$log.log(this.User.getCurrent());
		// this.$log.log(this.stripeAccount);

		// Assign linked banks accounts
		if (this.stripeAccount && this.stripeAccount.sources && this.stripeAccount.sources.data) {
			this.accounts = this.stripeAccount.sources.data;
		}

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/account/bank-accounts/account.bank-accounts.controller.js